export interface BrowserIdentityInput<TUser extends { id: string }> {
  skipSessionGate: boolean
  sessionPending: boolean
  sessionError?: boolean
  sessionInvalidated?: boolean
  userPending: boolean
  revalidating?: boolean
  sessionUserId: string | null
  browserSessionId: string | null
  user: TUser | null | undefined
}

export function resolveBrowserIdentity<TUser extends { id: string }>({
  skipSessionGate,
  sessionPending,
  sessionError = false,
  sessionInvalidated = false,
  userPending,
  revalidating = false,
  sessionUserId,
  browserSessionId,
  user,
}: BrowserIdentityInput<TUser>): {
  authResolved: boolean
  userInfo: TUser | null
  browserSessionId: string | null
} {
  if (revalidating || (!skipSessionGate && sessionError))
    return { authResolved: false, userInfo: null, browserSessionId: null }
  if (sessionInvalidated)
    return { authResolved: true, userInfo: null, browserSessionId: null }
  if (skipSessionGate) {
    return {
      authResolved: !userPending,
      userInfo: user ?? null,
      browserSessionId: null,
    }
  }
  if (sessionPending)
    return { authResolved: false, userInfo: null, browserSessionId: null }
  if (!sessionUserId)
    return { authResolved: true, userInfo: null, browserSessionId: null }
  if (userPending || !user || user.id !== sessionUserId || !browserSessionId) {
    return { authResolved: false, userInfo: null, browserSessionId: null }
  }
  return { authResolved: true, userInfo: user, browserSessionId }
}
